<div class="row" [ngClass]="{ 'mt-4 mb-4': mappedData && mappedData.length > 0 }">
  <div *ngFor="let data of mappedData; last as isLast" class="col-6 col-md-4 col-lg-{{ itemsPerRow }} mb-2">
    <div class="card product-card border">
      <div class="card-body text-center">
        <div>
          <span class="return-policy"
            *ngIf="data.product.extra.validForReturnMap && data.product.extra.validForReturnMap[customerPriceList] && data.product.extra.validForReturnMap[customerPriceList] == '1'">
            {{ 'RETURN_VALID' | translate }}
          </span>
          <span class="favourite-icon-wrapper">
            <lib-favourite-product-icon [id]="data.product.id"></lib-favourite-product-icon>
          </span>
        </div>
        <div class="image-wrapper" (click)="goToDetail(data.product)">
          <img *ngIf="data.product.extra.images && data.product.extra.images[0] as image; else noimage"
            class="img-fluid"
            src="https://cdn3.gung.io/fit-in/250x250/filters:etag({{ image.s3ETag }}):background_color(white):format(jpeg):fill(fff)/{{ image.s3Uri }}"
            alt="" />
          <ng-template #noimage>
            <img class="card-img-top img-fluid w-100"
              src="https://cdn3.gung.io/fit-in/300x300/images/no-image.jpg" alt="NO IMAGE"
              class="img-fluid mx-auto d-block" />
          </ng-template>
        </div>
        <div class="product-text">
          <lib-availability [availability]="data.availability" [isSales]="isSales" [product]="data.product"
            *ngIf="includeAvailability"></lib-availability>
          <div class="text-truncate" translate>{{ data.product.name }}</div>
          <small>Art no: <span translate>{{ data.product.id }}</span></small>
          <div class="small" *ngIf="data.product.extra.pim?.ar_q_wa_eankod_konsument">
            <span>
              <span translate>EAN</span>:&nbsp;<span>{{ data.product.extra.pim.ar_q_wa_eankod_konsument }}</span>
            </span>
          </div>
          <div [ngClass]="{ 'is-clearance': !isReturnFlow && data.product.extra.ar.q_eliasson_artnr === '50' }">
            <lib-price [price]="data.price" type="NET" [currency]="data.price.customerNetPrice.currencyCode"
              class="font-weight-bold"></lib-price>&nbsp;
            <span *ngIf="data.price.customerDiscountPercent !== 0">(-{{ data.price.customerDiscountPercent }}%)</span>
          </div>
        </div>
        <cult-buy-btn class="mt-2" [id]="data.product.id" [product]="data.product"></cult-buy-btn>
      </div>
    </div>
  </div>
  <div *ngIf="findError" class="col-12 mb-2 text-center">
    {{ errorMessage }}
  </div>
</div>